import { FaWhatsapp } from "react-icons/fa";
import "./WhatsAppButton.css";

const PHONE = "919500886368";

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${PHONE}?text=${encodeURIComponent(
        "Hi Firm Fit Factory, I'd like to know more about your programs."
      )}`}
      target="_blank"
      rel="noopener noreferrer"
      className="whatsapp-fab"
      aria-label="Chat with Firm Fit Factory on WhatsApp"
    >
      <FaWhatsapp aria-hidden="true" />
    </a>
  );
}
